module.exports = __webpack_public_path__ + "img/verify.8049742c.svg";